// extracted by mini-css-extract-plugin
export default {"formContents":"ConfirmationPrompt_formContents__qfue9"};